import { Colors } from "@/enums/Colors";
import { ExpandMore } from "@mui/icons-material";
import { Select, SelectProps, styled } from "@mui/material";

export const CommonStyledSelect = styled(<T = any,>(props: SelectProps<T>) => <Select IconComponent={ExpandMore} {...props} />)({
  fontSize: "0.875rem",
  fontWeight: "400",
  height: "2.750rem",
  color: `${Colors.BLACK}`,
  backgroundColor: "white",
  borderRadius: "0.7rem",
  "& .MuiOutlinedInput-notchedOutline": {
    border: `1px solid ${Colors.LIGHT_GRAY_DEDEE1}`,
  },
  "&.Mui-focused": {
    border: `0.062rem solid ${Colors.BUTTON_PURPLE}`,
    "& .MuiOutlinedInput-notchedOutline": {
      borderWidth: "1px",
    },
  },
}) as <T = any>(props: SelectProps<T>) => JSX.Element;

export const CommonStyledSelectMenuProps = {
  PaperProps: {
    sx: {
      marginTop: "0.250rem",
      border: `1px solid ${Colors.LIGHT_GRAY_DEDEE1}`,
      maxHeight: "30rem",
      borderRadius: "0.5rem",
      boxShadow: `0 0 0.938rem rgba(0, 0, 0, 0.2)`,
      "& .MuiMenuItem-root": {
        gap: "0.500rem",
        padding: "0.375rem 0.750rem",
        fontSize: "0.875rem",
        color: `${Colors.BLACK_151517}`,
        "&.Mui-selected": {
          backgroundColor: Colors.BUTTON_SECONDARY_PURPLE,
        },
      },
    },
  },
};
